import { NgStyle } from '@angular/common';
import { Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import { getContrastColorSafe } from '@shared-angular';
import { BotQuickinfoComponent } from '../../utils/bot-quickinfo/bot-quickinfo.component';

@Component({
  selector: 'app-bot-admin-card-body-content',
  templateUrl: './bot-admin-card-body-content.component.html',
  styleUrl: './bot-admin-card-body-content.component.scss',
  imports: [NgStyle,  BotQuickinfoComponent]
})
export class BotAdminCardBodyContentComponent {
  public readonly botConfig = input.required<ChatbotConfig>();
  constructor(public router: Router) {



  }
  public getContrastColor = getContrastColorSafe;

}
